(() => {
  const STYLE_ID = 'bcg-forms-style';

  const CSS = `
    form {
      gap: 5px !important;
    }

    section {
      margin: 0 auto 8px !important;
      padding: 0 !important;
    }

    h2 {
      font-size: 2rem !important;
      line-height: 1.2 !important;
      margin: 0 0 6px !important;
    }

    .my-4 {
          margin-top: 5px !important;
          margin-bottom: 5px !important;
    }

    p {
      margin: 0 0 5px !important;
      line-height: 1.35 !important;
    }
  `;

  function applyShopifyFormsStyles() {
    let styledCount = 0;

    document
      .querySelectorAll('shopify-forms-embed')
      .forEach((host) => {
        const root = host.shadowRoot;
        if (!root) return;

        let style = root.getElementById(STYLE_ID);

        if (!style) {
          style = document.createElement('style');
          style.id = STYLE_ID;
          root.appendChild(style);
        }

        if (style.textContent !== CSS) {
          style.textContent = CSS;
        }

        styledCount++;
      });

    return styledCount;
  }

  function init() {
    applyShopifyFormsStyles();

    const observer = new MutationObserver(() => {
      applyShopifyFormsStyles();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Fallback ngắn cho trường hợp Shopify Forms load trễ.
    let attempts = 0;

    const timer = setInterval(() => {
      const styledCount = applyShopifyFormsStyles();
      attempts++;

      // Nếu đã thấy form hoặc đã thử đủ 8 lần (~4 giây) thì dừng polling.
      if (styledCount > 0 || attempts >= 4) {
        clearInterval(timer);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();